import React from 'react'
import { BasicDropdown, SearchInput } from '..'
// import { SelectCheckbox } from '../dashboard-form';

// const options = [
//   {
//     label: 'Pemuda',
//     value: 'pemuda',
//   },
//   {
//     label: 'Perempuan',
//     value: 'perempuan',
//   },
//   {
//     label: 'Tokoh Agama',
//     value: 'tokoh_agama',
//   },
//   {
//     label: 'Pelajar',
//     value: 'pelajar',
//   },
//   {
//     label: 'Universitas',
//     value: 'universitas',
//   },
//   {
//     label: 'Korban',
//     value: 'korban',
//   },
//   {
//     label: 'Returnee',
//     value: 'returnee',
//   },
//   {
//     label: 'Eks-anggota',
//     value: 'eks_anggota',
//   },
// ];

// const optionsDate = [{
//   label: 'Past 30 Days',
//   value: 0
// }]

const FilterForm = ({id}) => {
  return (
    <div>
      <div className="mb-8">
        <p className="font-bold text-sm mb-4">Search by Keyword</p>
        <SearchInput disabled={true}/>
      </div>
      <div className="mb-8">
        <p className="font-bold text-sm mb-4">Type</p>
        <BasicDropdown
          placeholder="Knowledge Product"
          options={[]}
          disabled={true}
        />
        <BasicDropdown
          placeholder="Approach"
          multi
          options={[
            {label: 'Pemuda', value: 1},
            {label: 'Perempuan', value: 2}
          ]}
          disabled={true}
        />
        {/* <SelectCheckbox className="text-sm" options={options} placeholder="Issue"/> */}
      </div>
      {/* <div className="mb-8">
        <p className="font-bold text-sm mb-4">Location</p>
        <BasicDropdown
          placeholder="Province"
          options={[]}
        />
        <BasicDropdown
          placeholder="City"
          options={[]}
          disabled={true}
        />
      </div>
      <div>
        <p className="font-bold text-sm mb-4">Date</p>
        <BasicDropdown
          placeholder="Date"
          options={optionsDate}
          defaultValue={optionsDate[0]}
        />
      </div> */}
    </div>
  )
}

export { FilterForm }